export const UPDATE_FUNDINGS = 'UPDATE_FUNDINGS'
export const UPDATE_FUNDINGS_SEARCH_TERM = 'UPDATE_FUNDINGS_SEARCH_TERM'
export const UPDATE_FUNDINGS_SEARCH_RESULT = 'UPDATE_FUNDINGS_SEARCH_RESULT'
export const UPDATE_FUNDINGS_CATEGORY = 'UPDATE_FUNDINGS_CATEGORY'
export const UPDATE_LEAGUE_WIDE_FUNDING = 'UPDATE_LEAGUE_WIDE_FUNDING'
